/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-simcard': {
    width: 7,
    height: 9,
    viewBox: '0 0 7 9',
    data: '<path pid="0" d="M6.833 2.216a.167.167 0 0 1 .049.117v5.5a.667.667 0 0 1-.667.667H1.548a.667.667 0 0 1-.666-.667V1.167C.882.799 1.18.5 1.548.5h3.5c.044 0 .086.018.118.049l1.667 1.667zm-3.785 4.95v-.833h-.833V7c0 .092.075.167.167.167h.666zm1.334 0v-.833h-1v.834h1zm1 0A.167.167 0 0 0 5.548 7V5H2.215v1h2.333c.092 0 .167.075.167.167v1h.667zm-.667-3.333v.834h.833V4a.167.167 0 0 0-.166-.167h-.667zm-1.333 0v.834h1v-.834h-1zm-.334.834v-.834h-.666A.167.167 0 0 0 2.215 4v.667h.833z" _fill="#000" fill-rule="nonzero"/>'
  }
})
